import logo from '../shared/img/logo.svg'

export const images = {
    logo: logo
}